const KEY = 'pac_attribution';

export function initAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const utm = {
      utmSource: params.get('utm_source') || '',
      utmMedium: params.get('utm_medium') || '',
      utmCampaign: params.get('utm_campaign') || '',
      utmTerm: params.get('utm_term') || '',
      utmContent: params.get('utm_content') || '',
    };
    const hasUtm = Object.values(utm).some(Boolean);
    const existing = JSON.parse(sessionStorage.getItem(KEY) || 'null');

    if (!existing) {
      sessionStorage.setItem(KEY, JSON.stringify({
        ...utm,
        referrer: document.referrer || '',
        landingPage: window.location.pathname || '/',
      }));
    } else if (hasUtm) {
      // A fresh campaign link was clicked mid-session; refresh UTM data.
      sessionStorage.setItem(KEY, JSON.stringify({ ...existing, ...utm }));
    }
  } catch (e) {
    // sessionStorage unavailable (private mode etc.) — ignore.
  }
}

export function getAttribution() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || '{}');
  } catch (e) {
    return {};
  }
}
